import { render, staticRenderFns } from "./RequestProperty.vue?vue&type=template&id=0fbea068&scoped=true&"
import script from "./RequestProperty.vue?vue&type=script&lang=js&"
export * from "./RequestProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbea068",
  null
  
)

export default component.exports